import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { FirebaseAuthenticationService } from '@modules/chat/firebase-authentication.service';
import { AuthenticationCredentialsService } from '@modules/authentication/services/authentication-credentials.service';
import { catchError, of, switchMap } from 'rxjs';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';

export const isFirebaseAuthenticatedGuard: CanActivateFn = () => {
  const firebaseAuthenticationService = inject(FirebaseAuthenticationService);
  const authenticationCredentialsService = inject(AuthenticationCredentialsService);
  const authenticationService = inject(AuthenticationService);

  if (!authenticationCredentialsService.getRtpToken()) {
    return authenticationService.refreshRtpToken().pipe(
      switchMap(() => firebaseAuthenticationService.authenticate()),
      catchError(() => of(false)),
    );
  }
  return firebaseAuthenticationService.authenticate();
};
